/**
 * Centralized feature flag system — driven by environment variables.
 *
 * Each flag maps to a `FF_<FLAG_NAME>` env var (e.g. FF_ENABLE_CONFERENCE_CALLS).
 * Values are read at first access and cached.
 *
 * To add a new feature flag:
 * 1. Add the flag name and its default value to FEATURE_FLAG_DEFAULTS below
 * 2. Add the corresponding FF_ env var to env.master.ts and copy-envs.ts
 * 3. Use FeatureFlags.FLAG_NAME to check the flag
 */

const FEATURE_FLAG_DEFAULTS: Record<string, boolean> = {
  ENABLE_LLM_VOICE_STREAMING: true,
  ENABLE_CONFERENCE_CALLS: false
};

function resolveFlag(name: string): boolean {
  const envVal = process.env[`FF_${name}`];
  if (envVal !== undefined) {
    return envVal === "1" || envVal.toLowerCase() === "true";
  }
  return FEATURE_FLAG_DEFAULTS[name] ?? false;
}

type FeatureFlagKeys = {
  ENABLE_LLM_VOICE_STREAMING: boolean;
  ENABLE_CONFERENCE_CALLS: boolean;
};

export const FeatureFlags = new Proxy({} as FeatureFlagKeys, {
  get(_target, prop: string) {
    return resolveFlag(prop);
  }
});
